import { render, staticRenderFns } from "./DataProtectionForm.vue?vue&type=template&id=764bbd7a&"
import script from "./DataProtectionForm.vue?vue&type=script&lang=js&"
export * from "./DataProtectionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports